module.exports = __webpack_public_path__ + "img/Resume_Print.6ddd519d.jpg";